/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
   app.controller('StammdatenConfigCtrl', ['$scope', '$http', 'NetworkService', function ($scope, $http, NetworkService) {

            $scope.anrede = "";
            $scope.vorname = "-1";
            $scope.strasse = "";
            $scope.handynummer = "";
            //$scope.tshirt = "S";
                   
            fields = {}
            fields["command"] = "getStammdaten"
            var req = {
                method: 'POST',
                url: "Api/hosiapi.php",
                data: $.param(fields),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            }


            $scope.updateUser = function ()
            {
                data = {anrede: $scope.anrede,
                    vorname: $scope.vorname,
                    nachname: $scope.nachname,
                    strasse: $scope.strasse,
                    postleitzahl: $scope.plz,
                    ort: $scope.ort,
                    tshirtgroesse: $scope.tshirt,
                    handynummer: $scope.handynummer,
                    email: $scope.email,
                    magruppe: $scope.magruppe,
                    essen: "",
                    geburtstag: $scope.geburtstag,
                    laendercode: $scope.laendercode}

                NetworkService.updateUser(data, function (data) {
                    console.log(data)
                })
            }
            $scope.selectedIfEquals = function (el, el2)
            {
                ret = false;
                if (el == el2)
                {
                    ret = true
                }
                console.log(el2)
                return ret;
            }
            $http(req).then(function (data) {
                //$scope.data = data.data["position"];
                data = data.data[0]
                $scope.anrede = data.anrede;
                $scope.vorname = data.vorname;
                $scope.nachname = data.nachname;
                $scope.strasse = data.strasse;
                $scope.plz = data.plz;
                $scope.ort = data.ort;
                $scope.tshirt = data.tshirt;
                $scope.handynummer = data.handynummer;
                $scope.email = data.email;
                $scope.magruppe = "";
                $scope.referenz = ""
                $scope.geburtstag = data.geburtstag;
                $scope.laendercode = data.laendercode
                $scope.tshirt = data.tshirt
                 $("select").css("display", "block")//material_select()
            }, "json");
        }])


